import React, { useEffect, useState } from "react";
import Joi from "joi-browser";
import Form from "../../comman/form";
import useControls from "../../app/hooks/useControls";
import useForm from "../../app/hooks/useForm";

const LoginStep2 = ({ handleDoSubmit, userError, type, handleForgotPwd }) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const schema = {
    username: Joi.string().required().label("Username"),
    password: Joi.string().required().label("Password"),
  };

  const doSubmit = async () => {
    setIsProcessing(true);
    try {
      await handleDoSubmit(stateData);
    } catch (err) {
      setIsProcessing(false);
    }
  };

  const {
    stateData,
    setStateData,
    stateErrors,
    setStateErrors,
    handleChange,
    validate,
    handleSubmit,
  } = useForm(schema, doSubmit);

  useEffect(() => {
    if (userError !== undefined) {
      setStateErrors((prev) => ({
        ...prev,
        username: userError,
      }));
      setIsProcessing(false);
    }
  }, [userError, setStateErrors]);



  const { renderInput } = useControls(
    stateData,
    stateErrors,
    handleChange,
    schema
  );

    return (
      <React.Fragment>
        <div>
          {renderInput("username", "Enter Your Username")}

          {renderInput("password", "Enter Your Password", "password")}

          <div>
            <button
              className="wf-login-btn-primary"
              disabled={validate() || isProcessing}
              onClick={handleSubmit}
            >
              {isProcessing ? (
                <React.Fragment>
                  <i className="fa fa-refresh fa-spin mr-2" aria-hidden="true"></i>
                  Signing In...
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <i className="fa fa-sign-in mr-2" aria-hidden="true"></i>
                  Sign In
                </React.Fragment>
              )}
            </button>
          </div>

          <div className="mt-3 text-right">
            <button
              onClick={handleForgotPwd}
              type="button"
              className="login-link"
              style={{ border: "none", background: "none", boxShadow: "none", textDecoration: "none", cursor: "pointer", padding: 0 }}
            >
              Forgot Username/Password?
            </button>
          </div>

        </div>
      </React.Fragment>
    );
  }

export default LoginStep2;
